<template>
	<div class="BookComment" @click.self="CloseStars">
		<!-- mobile 评论Text -->
		<div class="titleReturn">
			<div class="return" @click="CommentReturn"></div>
			评价
		</div>
		<!-- pc_评价 -->
		<div class="commentWrap">
			<h3>评价</h3>
			<div class="starswrap">
				<span class="commentText">评分</span>
				<el-rate v-model="score"></el-rate>
			</div>
			<el-input
				type="textarea"
				:rows="4"
				placeholder="内容不能为空。"
				maxlength="500"
				show-word-limit
				v-model="textarea">
			</el-input>
			<div class="commentBtnWrap"><p class="commentBtn" @click="PostComment">评价</p></div>
		</div>
		<!-- 全部评价 -->
		<div class="allCommentWrap" @click="CloseComment" @click.self="CloseStars">
			<p>{{'全部评价('+allCommentNum+')'}}</p>
			<p class="noComment" v-if="allCommentNum == 0">暂无评价</p>
			<div class="haveComment" v-else>
				<ul>
					<li v-for="(item,index) in allCommentList" :key="index">
						<div class="headPortrait"><img :src="item.imagePath" alt=""/></div>
						<div class="userCommentInfo">
							<p class="userName">{{item.nickName}}</p>
							<el-rate v-model="item.score" disabled disabled-void-icon-class="el-icon-star-off"></el-rate>
							<p class="userCommentText">{{item.contents}}</p>
							<span>{{item.creationDate}}</span>
						</div>
					</li>
				</ul>
				<p class="lookMoreComment" v-if="isshowMore" @click="LookMore">查看更多</p>
				<p class="nomore" v-else>已经到底了</p>
			</div>
		</div>
		<!-- mobile 评价 -->
		<div class="mobile_commentWrap">
			<div class="inputBox">
				<input type="text" v-model="textarea" :placeholder="inputText" @focus="OpenStars" />
				<span @click="PostComment">评价</span>
			</div>
			<div class="starswrap" v-show="showStars">
				<span class="commentText">评分</span>
				<el-rate v-model="score"></el-rate>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return{
			score:5,  // 评分
			textarea:'',  // 评价
			allCommentNum:0,  // 全部评价数
			allCommentList:[],  // 全部评论数组
			showStars:false,  // 显示总体评价
			inputText:'评论一下，内容不能为空',  // input未输入时文字
			InformationId:undefined,  // 情报id
			CurrentPage:1,  // 当前页
			isshowMore:true,  // 查看更多
		}
	},
	mounted() {
		// 获取情报id
		this.InformationId = this.$route.query.InformationId;
		// 获取评论列表
		this.GetComment();
	},
	methods:{
		// 获取评论列表
		GetComment(type){
			let params = '?PageNumber='+this.CurrentPage+'&PageSize=8&OrderByDictionary[DisplayIndex]=desc&OrderByDictionary[CreationDate]=desc';
			this.$fetch('/api/inforation/'+this.InformationId+'/informationComment'+params)
			.then((res)=>{
				let headers = JSON.parse(res.headers["x-pagination"]);
				// 如果点击加载更多就合并数组
				if(type == 'LoadMore'){
					this.allCommentList = this.allCommentList.concat(res.data);
				}else{
					this.allCommentList = res.data;
				}
				this.allCommentNum = headers.totalCount;
				// 判断是否 有下一页
				if(headers.hasNext){
					this.isshowMore = true;
				}else{
					this.isshowMore = false;
				}
			}).catch((err)=>{
				throw err;
			});
		},
		// 评价
		PostComment(){
			if (this.textarea == '') {
				this.$message({
					message: '评论内容不能为空！',
					type: 'warning'
				});
				return;
			}
			this.$post('/api/inforation/'+this.InformationId+'/informationComment',{
				"Score": this.score,
				"Contents": this.textarea
			}).then((res)=>{
				this.score = 5;
				this.textarea = '';
				this.GetComment();
			}).catch((err)=>{
				throw err;
			});
		},
		// 查看那更多
		LookMore(){
			this.CurrentPage++;
			this.GetComment('LoadMore');
		},
		// 返回
		CommentReturn(){
			this.$router.go(-1);
		},
		// 打开总体评价
		OpenStars(){
			this.showStars = true;
			this.inputText = '请输入';
		},
		// 关闭
		CloseStars(){
			this.showStars = false;
			this.inputText = '评论一下，内容不能为空';
		},
		// 关闭评价窗口
		CloseComment(){
			if(window.innerWidth >=  1029){
				return;
			}
			this.showStars = false;
		}
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
	.BookComment{
		width: 100%;
		height: 100%;
	}
	.commentWrap{
		display: none;
	}
	/* mobile 评论Text */
	.titleReturn{
		width: 100%;
		line-height: .88rem;
		text-align: center;
		font-size: .28rem;
		position: relative;
	}
	.titleReturn .return{
		width: .4rem;
		height: .4rem;
		background: url(../assets/img/return_mobile.svg) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		left: .25rem;
		top: 50%;
		transform: translateY(-50%);
	}
	/* 全部评论 */
	.allCommentWrap{
		padding: 0 .25rem;
		height: calc(100% - 1.86rem);
	}
	/* 评论 */
	.mobile_commentWrap{
		width: 100%;
		padding: .13rem .25rem;
		background-color: #FFFFFF;
		position: fixed;
		bottom: 0;
		left: 0;
	}
	.inputBox{
		font-size: .28rem;
		color: #999EAC;
	}
	.inputBox input{
		width: 5.99rem;
		height: .72rem;
		padding: 0 .3rem;
		background: #F5F5F7;
		border-radius: .36rem;
	}
	.starswrap{
		display: flex;
		align-items: center;
		line-height: .8rem;
		padding: 0 .25rem;
	}
	.starswrap .commentText{
		font-size: .24rem;
		color: #BBBBBB;
		margin-right: .3rem;
	}
}
@media screen and (min-width: 1029px) {
	.BookComment{
		width: 100%;
		margin-top: 30px;
	}
	.titleReturn,.mobile_commentWrap{
		display: none;
	}
	/* 全部评论 */
	.allCommentWrap{
		border-top: 1px solid #F5F5F5;
	}
	.starswrap{
		display: flex;
		align-items: center;
		margin: 30px 0 20px;
	}
	.starswrap .commentText{
		font-size: 16px;
		color: #424242;
		letter-spacing: 0;
		line-height: 16px;
		margin-right: 10px;
	}
}
.BookComment h3{
	font-size: 24px;
	color: #424242;
	letter-spacing: 0;
	line-height: 24px;
}
/* 评论 */
.commentBtnWrap{
	display: flex;
	justify-content: flex-end;
}
.commentBtn{
	width: 102px;
	margin: 20px 0 16px;
	font-size: 16px;
	line-height: 34px;
	color: #FFFFFF;
	background: #286AF2;
	border-radius: 2px;
	text-align: center;
	cursor: pointer;
}
/* 全部评论 */
.allCommentWrap{
	padding-top: 20px;
}
.allCommentWrap>p:first-child,.haveComment>p{
	font-size: 14px;
	color: #424242;
	letter-spacing: 0;
}
.allCommentWrap ul{
	margin-top: 20px;
}
.allCommentWrap ul li{
	display: flex;
	padding: 20px 0;
	border-bottom: 1px solid #F5F5F5;
}
.headPortrait>img{
	width: 48px;
	height: 48px;
	border-radius: 50%;
}
.userCommentInfo{
	margin-left: 20px;
}
.userCommentInfo .userName{
	font-size: 14px;
	color: #19191A;
	letter-spacing: 0;
	line-height: 14px;
	margin-bottom: 10px;
}
.userCommentInfo .userCommentText{
	font-size: 14px;
	color: #424242;
	letter-spacing: 0.5px;
	line-height: 28px;
	margin: 10px 0;
}
.userCommentInfo>span{
	font-size: 12px;
	color: rgba(25,25,26,0.40);
	letter-spacing: 0;
	line-height: 12px;
}
.lookMoreComment{
	background: #FBFBFB;
	line-height: 48px;
	text-align: center;
	font-size: 18px;
	color: #424242;
	margin: 20px 0 40px;
	cursor: pointer;
}
.allCommentWrap .nomore{
	font-size: 16px;
	color: #CCCCCC;
	text-align: center;
	line-height: 40px;
}
/* 暂无评论 */
.noComment{
	color: #424242;
	font-size: 24px;
	margin: 30px 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment.vue